<script setup lang="ts">
import { internalRoles } from '~/authorization/roles'

const { $trpc, queryClient, useMutation, makeTrpcErrorToast } = useMutationHelpers()
const notification = useNotification()

const { openDefectRepairPopup: { data: popupData, close: closePopup } } = useGlobalOpeners()

const { useremail, hasAnyAssignedRole } = useAuthorization()
const isAllowedFullAccess = hasAnyAssignedRole(internalRoles)

const { defect: queryDefect, comment } = useQuery()
const { data: defect, isLoading: isLoadingDefect } = queryDefect.byId(computed(() => popupData.value?.id))

const { data: defectOwnCommentCount } = comment.countAllByTypeAndEntityId(computed(() => ({ type: 'Defect', entityId: popupData.value?.id, userEmail: useremail.value })))

const enableSubmitButton = computed(() => isAllowedFullAccess.value || (defectOwnCommentCount.value && defectOwnCommentCount.value > 0))

const repair = useMutation({
  mutationFn: $trpc.defect.repair.mutate,
  onError: makeTrpcErrorToast(notification, { description: 'Der Defekt konnte nicht aktualisiert werden' }),
  onSuccess: async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: ['defect'] }),
      queryClient.invalidateQueries({ queryKey: ['machines'] }),
    ])
    closePopup()
    notification.success({ title: 'Der Defekt wurde erfolgreich aktualisiert', duration: 4500 })
  },
})
const formkitPlugins = useFormkitPlugins()
</script>

<template>
  <ThePopup v-if="defect && !isLoadingDefect" :show="Boolean(defect)" :title="`Reparatur ${defect[`${defect.type}Id`]}`" @close="closePopup">
    <div class="flex flex-col gap-5">
      <n-alert v-if="!isAllowedFullAccess" type="info">
        {{ $t('defect.repair.popup.info.label') }}
      </n-alert>
      <CommentList :id="defect.id" type="Defect" :is-visibility-adjustable="isAllowedFullAccess" class="mb-5" />
      <FormKit type="form" :disabled="!enableSubmitButton" :plugins="[formkitPlugins]" :submit-label="$t('defect.repair.save.button.label')" @submit="repair.mutate({ id: defect.id })" />
    </div>
  </ThePopup>
</template>
